<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#182444"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#182444" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 sm6 md8 text-left>
        <span class="mainHeader">Voters List</span>
      </v-flex>
      <v-flex xs12 sm3 md2 class="buttons1" pt-2 pt-sm-0 text-right>
        <download-excel :data="myData" :fields="json_fields">
                <v-btn
                  width="155px"
                  dark
                  style="text-transform: none"
                  color="#2a3553"
                  >Download Excel</v-btn
                >
              </download-excel>
     </v-flex>
      <!-------------------------ADD CUSTOMER TO SCHEME----------------------------->
      <v-flex xs12 sm3 md2 class="buttons1" pt-2 pt-sm-0 text-right>
        <v-btn dark color="#182444" @click="(addUser = true),(setDefaults())" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add New
        </v-btn>
      </v-flex>
      </v-layout>
    <v-layout wrap pt-2>
      <v-flex xs12 sm2 md2 pr-1 text-right>
        <v-select
                        outlined
                        hide-details
                        dense
                        clearable
                        background-color="white"
                        v-model="newGender"
                        :items="genderList"
                        label="Choose gender"
                      ></v-select>
                      </v-flex>
      <v-flex xs12 sm2 md2 pr-1 text-right>
                      <v-select
                        outlined
                        hide-details
                        dense
                        clearable
                        background-color="white"
                        v-model="newAge"
                        :items="ageList"
                        label="Choose age"
                      ></v-select>
      </v-flex>

      <v-flex xs12 sm2 md2 pr-1 text-right>

            <v-autocomplete
              background-color="white"
                :items="boothList"
                v-model="boothFilter"
                label="Choose booth"
                item-text="name"
                item-value="_id"
                outlined clearable
                hide-details color="#182444"
                dense
              ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm2 md2 pr-1 text-right>
        <v-select
                        outlined
                        hide-details
                        dense
                        background-color="white"
                        v-model="casteFilter"
                        :items="casteList"
                        label="Choose caste"
                      ></v-select>
      </v-flex>
      <v-flex xs12 sm2 md2 pr-1 text-right>
        <v-select
                        outlined
                        hide-details
                        dense
                        background-color="white"
                        v-model="religionFilter"
                        :items="religionList"
                        label="Choose religion"
                      ></v-select>
      </v-flex>
      <v-flex xs12 sm2 md2 pr-1 text-right>
      <v-text-field
                        label="Search voter"
                        v-model="keyword"
                        outlined
                        append-icon="mdi-magnify"
                        dense clearable
                        hide-details
                        background-color="white"
                        color="#50659f"
                      ></v-text-field>
                      </v-flex>
    </v-layout>
    <v-layout wrap>
       <!-------------------------LIST OF CUSTOMER IN SCHEME----------------------------->
      <v-flex xs12 py-6 text-left>
        <v-card
          class="rounded-lg"
          elevation="0"
          :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'"
          :flat="$route.name == 'Dashboard' ? true : false"
        >
          <v-layout wrap pa-4 v-if="voterList">
            <v-flex xs12 v-if="voterList.length > 0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont"><b>S.No.</b></th>
                      <th class="text-left tablefont"><b>Voter</b></th>
                      <th class="text-left tablefont"><b>Age</b></th>
                      <th class="text-left tablefont"><b>Gender</b></th>
                      <th class="text-left tablefont"><b>Contact</b></th>
                      <th class="text-left tablefont"><b>Booth</b></th>
                      <th class="text-left tablefont"><b>Caste</b></th>
                      <th class="text-left tablefont"><b>Religion</b></th>
                      <th class="text-left tablefont"><b>Actions</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in voterList" :key="i" class="table" >
                      <!-- <td>{{ i + 1 }}</td> -->
                      <td>
                        <span v-if="page == 1">
                          {{ i + 1 }}
                        </span>
                        <span v-else>
                          {{ i + 1 + 20 * (page - 1) }}
                        </span>
                      </td>
                      <td>
                        <span v-if="value.name">{{
                          value.name
                        }} {{
                          value.lastname
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.age">{{
                          value.age
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.gender">{{
                          value.gender
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.phone">{{
                          value.phone
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.boothId">{{
                          value.boothId.name
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.caste">{{
                          value.caste
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.religion">{{
                          value.religion
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td class="text-center">
                         <v-layout wrap>
                          <!-- <v-flex xs2>
                            <v-icon
                            size="18"
                            title="View voters"
                            style="cursor: pointer"
                            color="#182444"   @click="(viewDetails = true),(userDetails=value)"
                            >mdi-eye</v-icon
                          >
                          </v-flex> -->
                          <v-flex xs3>
                            <v-icon
                            size="18"
                            color="#182444"
                            style="cursor: pointer"
                            @click="(deletedialog = true), (DeleteId = value._id)"
                            >mdi-delete</v-icon
                          >
                          </v-flex>
                          <v-flex xs2>
                            <v-icon
                          size="18"
                          color="#182444"
                          style="cursor: pointer"
                          @click="(dialogedit = true), (editItem = value)"
                          >mdi-pencil</v-icon
                        >
                          </v-flex>
                         </v-layout>
                        </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
            <v-flex xs12 v-else pa-4 text-center class="tablefont1"> No data found </v-flex>
          </v-layout>
        </v-card>
        <v-layout wrap v-if="voterList">
          <v-flex xs12 pt-4 v-if="voterList.length > 0">
            <v-pagination
              small
              color="#182444"
              v-model="page"
              :length="Pagelength"
            >
            </v-pagination>
          </v-flex>
        </v-layout>
        <v-dialog width="400px" v-model="deletedialog">
            <v-card width="400px" class="pa-2">
             
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Delete</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                  @click="deletedialog = false"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-card-text class="pa-4"
                >Are you sure you want to delete this voter?
              </v-card-text>
              <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <!-- <v-btn
                  color="grey"
                  text
                  class="button1"
                  @click="deletedialog = false"
                  >Cancel</v-btn
                > -->
                <v-btn
                  color="#182444"
                  class="button1"
                  dark
                  @click="deleteVoter(DeleteId)"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
      <!-------------------------ADD voters ----------------------------->
      <v-dialog width="800px" v-model="addUser">
          <v-form v-model="addcat2" ref="addcat2" @submit.prevent>
            <v-card tile width="800px" class="rounded-lg px-4">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center
                  ><span style="color: #182444" class="menuhead1"
                    >Add Voter</span
                  ></v-flex
                >
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(addUser = false),(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-2>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        type="text"
                        label="Name"
                        v-model="name"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Mobile Number </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Contact"
                        v-model="phone"
                        outlined
                        color="#50659f"
                        :rules="phoneRules"
                        dense
                        type="number"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Email Address </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        :rules="[rules.email]"
                        type="email"
                        label="Enter Email"
                        v-model="email"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Gender</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#50659f"
                        v-model="gender"
                        :items="genderList"
                        label="Choose Gender"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">DOB</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="dob"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dob"
                    label="DOB"
                    background-color="white"
                    outlined color="#50659f"
                    readonly
                    hide-details
                    clearable
          dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dob"
                  no-title
                  scrollable
                  @change="$refs.menu2.save(dob)"
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Age</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="number"
                        label="Enter Age"
                        v-model="age"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Caste</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="caste"
                        :items="casteList"
                        label="Choose Caste"
                      ></v-select>
                      <!-- <v-text-field
                        color="#50659f"
                        type="text"
                        label="Caste"
                        v-model="caste"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Religion</span>
                    </v-flex>
                    <v-flex xs12>
                      <!-- <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter Religion"
                        v-model="religion"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="religion"
                        :items="religionList"
                        label="Choose religion"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Booth</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="boothList"
                        v-model="Newbooth"
                        label="Select Booth"
                        item-text="name"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddVoter()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="800px" v-model="dialogedit">
            <v-card tile width="800px" class="px-4 py-4 rounded-lg">
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Edit Voter</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="dialogedit = false"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        type="text"
                        label="Name"
                        v-model="editItem.name"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Mobile Number </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Contact"
                        v-model="editItem.phone"
                        outlined
                        color="#50659f"
                        :rules="phoneRules"
                        dense
                        type="number"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Email Address </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#50659f"
                        :rules="[rules.email]"
                        type="email"
                        label="Enter Email"
                        v-model="editItem.email"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Gender</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#50659f"
                        v-model="editItem.gender"
                        :items="genderList"
                        label="Choose Gender"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">DOB</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="dob"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editItem.dob"
                    label="DOB"
                    background-color="white"
                    outlined color="#50659f"
                    readonly
                    hide-details
                    clearable
          dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editItem.dob"
                  no-title
                  scrollable
                  @change="$refs.menu2.save(dob)"
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Age</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="number"
                        label="Enter Age"
                        v-model="editItem.age"
                        outlined
                        dense
                        color="#50659f"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Caste</span>
                    </v-flex>
                    <v-flex xs12>
                      <!-- <v-text-field
                        color="#50659f"
                        type="text"
                        label="Caste"
                        v-model="editItem.caste"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="editItem.caste"
                        :items="casteList"
                        label="Choose Caste"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Religion</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="editItem.religion"
                        :items="religionList"
                        label="Choose religion"
                      ></v-select>
                      <!-- <v-text-field
                        color="#50659f"
                        type="text"
                        label="Enter Religion"
                        v-model="editItem.religion"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
                
                <v-flex xs6 py-1>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Booth</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="boothList"
                        v-model="editItem.boothId"
                        label="Select Booth"
                        item-text="name"
                        item-value="_id"
                        outlined
                        hide-details
                        dense
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="editVoter()"
                        ><v-icon>mdi-pencil</v-icon>Edit</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
        </v-dialog>
        <v-dialog width="800px" v-model="viewDetails">
          <v-card width="800px" class="rounded-lg" >
            <v-layout wrap dense flat justify-center class="body-2">
              <v-flex xs12 pt-4 text-center
                ><span class="menuhead1" style="color: #3f053c"
                  >User Details</span
                ></v-flex
              >
              <v-flex xs8 text-center py-4>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
            <v-layout wrap px-4>
            <v-flex xs6 v-if="userDetails.name"  text-left>
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2">Name : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1 text-left>
                      {{ userDetails.name }}  {{ userDetails.lastname }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex>
          
            <v-flex xs6 v-if="userDetails.phone"  text-left>
              <v-layout wrap pa-4>
                <v-flex xs3 class="subhead2"> Mobile : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.phone }}
                    </v-flex>
                  </v-layout>
            </v-flex>
            <v-flex xs6 text-left v-if="userDetails.email">
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2"> Email :</v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.email }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex>  
              <v-flex xs6 v-if="userDetails.gender"  text-left>
              <v-layout wrap pa-4>
                <v-flex xs3 class="subhead2"> Gender : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.gender }}
                    </v-flex>
                  </v-layout>
            </v-flex>
             <v-flex xs6 v-if="userDetails.age"  text-left>
              <v-layout wrap pa-4>
                <v-flex xs3 class="subhead2"> Age : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.age }}
                    </v-flex>
                  </v-layout>
            </v-flex>
             <v-flex xs6 v-if="userDetails.dob"  text-left>
              <v-layout wrap pa-4>
                <v-flex xs3 class="subhead2"> DOB : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ formatDate(userDetails.dob) }}
                    </v-flex>
                  </v-layout>
            </v-flex>
             <v-flex xs6 v-if="userDetails.caste"  text-left>
              <v-layout wrap pa-4>
                <v-flex xs3 class="subhead2">
                               Caste :
                            </v-flex>
                            <v-flex xs9 class="subhead3" pb-1>
                               {{userDetails.caste}}
                            </v-flex>
                  </v-layout>
            </v-flex>
             <v-flex xs6 v-if="userDetails.Religion"  text-left>
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2">Religion : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.Religion }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex>
             
             <v-flex xs6 v-if="userDetails.maritalStatus"  text-left>
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2">Marital Status : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.maritalStatus }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex>
            <v-flex xs6 v-if="userDetails.financialStatus"  text-left>
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2"> Financial Status : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.financialStatus }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex> 
            <v-flex xs6 text-left v-if="userDetails.profession">
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2">Profession : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.profession }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex> <v-flex xs6 text-left v-if="userDetails.instagram">
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2"> Instagram : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.instagram }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex> <v-flex xs6 text-left v-if="userDetails.facebook">
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2"> Facebook : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.facebook }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex> <v-flex xs6 text-left v-if="userDetails.twitter">
              <v-layout wrap pa-4>
                    <v-flex xs3 class="subhead2"> Twitter : </v-flex>
                    <v-flex xs9 class="subhead3" pb-1>
                      {{ userDetails.twitter }}
                    </v-flex>
                  
                  </v-layout>
            </v-flex> 
           
            </v-layout>

            <v-card-actions class="pt-3">
              <v-spacer></v-spacer>
              <v-btn
                color="grey"
                text
                class="body-2 font-weight-bold"
                @click="viewDetails = false"
                >Close</v-btn
              >
            
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      timeout: 2000,
      deletedialog: false,
      DeleteId: null,
      editItem: {},
      ServerError: false,
      appLoading: false,
      voterList:[],
      name: "",
      lastname: "",
      phone: "",
      email: "",
      gender: "",
      dob: "",
      age: "",
      caste: "",
      religion: "",
      maritalStatus:"",
      profession: "",
      twitter: "",
      instagram: "",
      facebook: "",
      Newbooth:"",
      genderList: ["Male", "Female", "Other"],
      ageList: ["Below 35", "Above 35", "Above 60"],
      financialList: ["Upper Class", "Middle Class", "Lower Class"],
      casteList: ["Forward Castes", "Scheduled Castes (SC)", "Scheduled Tribes (ST)","Other Backward Classes (OBC)","General Category","Not Applicable (NA)"],
      religionList: ["Christian", "Hindu", "Muslim","Atheist","Other","Not Applicable (NA)"],
      viewDetails:false,
      boothList:[],
      userDetails:[],
      page: 1,
      menu2:false,
      addcat2:false,
      currentPage: 1,
      addUser : false,
      dialogedit: false,
      boothFilter:"",
      ageFilter:"",
      religionFilter:"",
      casteFilter:"",
      newAge:"",
      newGender:"",
      keyword:"",
      //   curItem: {},
      msg: null,

      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) => (v && v.length <= 10) || "invalid number",
        (v) => (v && v.length >= 10) || "invalid number",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],
      //EXCEL
      json_fields: {
        Name: "name",
        Age: "age",
        Gender: "gender",
        Phone: "phone",
        Booth: "booth",
        Caste: "caste",
        Religion: "religion",
      },
      myData: [],
      excel: {
        name: "",
        age: "",
        gender: "",
        phone: "",
        booth: "",
        caste: "",
        religion: "",
      },
      //
    };
  },
  watch: {
    newAge(){
     this.changeAge(this.newAge);
    },
    newGender(){
     this.getVoter();
    },
    boothFilter(){
     this.getVoter();
    },
    casteFilter(){
     this.getVoter();
    },
    religionFilter(){
     this.getVoter();
    },
    keyword(){
     this.getVoter();
    },
   page() {
     this.getVoter();
   },
 },
 computed: {
    userData() {
      return this.$store.state.userData;
    },
    
    calculatedAge() {
      if (this.dob) {
        const dob = new Date(this.dob);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
          return age - 1;
        }
        console.log("age==",age)

        return age;
      }
      return '';
    },
  },
  mounted() { 
    if(this.$route.query.id=='1'){
    this.ageFilter = this.$route.query.id;
    this.newAge = 'Below 35';
    console.log("newage1==",this.newAge)
   }
   else if(this.$route.query.id=='2'){
    this.ageFilter = this.$route.query.id;
    this.newAge = 'Above 35';
    console.log("newage2==",this.newAge)

   }
   else if(this.$route.query.id=='3'){
    this.ageFilter = this.$route.query.id;
    this.newAge = 'Above 60';
    console.log("newage3==",this.newAge)

   }
   else if(this.$route.query.gender){
    this.newGender = this.$route.query.gender;
    console.log("newGender==",this.newGender)
   }
   else{
    this.ageFilter = "";
    this.newGender = "";
    this.getVoter();
   }
    this.getBooth();
    // this.getExcel();
  },

  methods: {
    changeAge(item){
      console.log("item==",item)
      if(item=='Below 35'){
        this.ageFilter='1';
        console.log("ageFilter=",this.ageFilter)
      }
      else if(item=='Above 35'){
        this.ageFilter='2';
        console.log("ageFilter=",this.ageFilter)

      }
      else if(item=='Above 60'){
        this.ageFilter='3';
        console.log("ageFilter=",this.ageFilter)

      }else{
        this.ageFilter='';
        console.log("ageFilter=",this.ageFilter)

      }
      console.log("finalageFilter=",this.ageFilter)

      this.getVoter()
    },
    setDefaults(){
    this.booth = this.$route.query.id;
    },
    resetForm() {
      this.$refs.addcat2.reset();
    },
    deleteVoter(id) {
      axios({
        url: "/voter/remove",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.deletedialog = false;
            this.DeleteId = 0;
            this.appLoading = false;
            this.getVoter();
          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    AddVoter() {
      this.appLoading = true;
      axios({
        url: "/voter/add",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.name,
      phone: this.phone,
      age: this.age,
      caste: this.caste,
      religion: this.religion,
      gender: this.gender,
      // lastname: this.lastname,
      // email: this.email,
      // dob: this.dob,
      // financialStatus: this.financialStatus,
      // maritalStatus: this.maritalStatus,
      // profession: this.profession,
      // twitter: this.twitter,
      // instagram: this.instagram,
      // facebook: this.facebook,
      boothId: this.Newbooth,
      // electionType : this.userData.electionType._id,
        },
      }) 
        .then((response) => {
          this.showsnackbar = true;
          this.addUser = false;
          this.msg = response.data.msg;
          this.name="";
     this.lastname="";
      this.phone="";
      this.email="";
      this.gender="";
      this.dob="";
      this.age="";
      this.caste="";
      this.religion="";
      this.financialStatus="";
      this.maritalStatus="";
      this.profession="";
      this.twitter="";
      this.instagram="";
      this.facebook="";
      this.Newbooth="";
      this.$refs.addcat2.reset();
          this.appLoading = false;
          this.getVoter();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    editVoter() {
      axios({
        url: "/voter/edit",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editItem._id,
          name: this.editItem.name,
      lastname: this.editItem.lastname,
      phone: this.editItem.phone,
      email: this.editItem.email,
      gender: this.editItem.gender,
      dob: this.editItem.dob,
      age: this.editItem.age,
      caste: this.editItem.caste,
      religion: this.editItem.religion,
      financialStatus: this.editItem.financialStatus,
      maritalStatus: this.editItem.maritalStatus,
      profession: this.editItem.profession,
      twitter: this.editItem.twitter,
      instagram: this.editItem.instagram,
      facebook: this.editItem.facebook,
        },
      })
        .then((response) => {
          this.dialogedit = false;
          this.editItem = {};
          this.showsnackbar = true;
          this.msg = response.data.msg;
          this.getVoter();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getVoter() {
      // console.log("role=",this.role)
      this.appLoading = true;
      axios({
        url: "/voter/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
          // gender: this.$route.query.gender,
          gender:this.newGender,
          age: this.ageFilter,
          boothId: this.boothFilter,
          caste: this.casteFilter,
          religion: this.religionFilter,
          keyword:this.keyword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.voterList = response.data.data;
          this.Pagelength = Math.ceil(response.data.totalLength / 50);
    this.getExcel();
        
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getExcel() {
      // console.log("role=",this.role)
      this.appLoading = true;
      axios({
        url: "/voter/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          gender:this.newGender,
          age: this.ageFilter,
          boothId: this.boothFilter,
          caste: this.casteFilter,
          religion: this.religionFilter,
          keyword:this.keyword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.myData = [];
          this.voterList = response.data.data;
         //excel
         for (let i = 0; i < response.data.data.length; i++) {
              if (response.data.data[i].name) {
                this.excel.name = response.data.data[i].name;
              }
             
              if (response.data.data[i].age) {
                this.excel.age =
                  response.data.data[i].age;
              }
              if (response.data.data[i].gender) {
                this.excel.gender = response.data.data[i].gender;
              }
              if (response.data.data[i].phone) {
                this.excel.phone = response.data.data[i].phone;
              } if (response.data.data[i].boothId.name) {
                this.excel.booth = response.data.data[i].boothId.name;
              } if (response.data.data[i].caste) {
                this.excel.caste = response.data.data[i].caste;
              } if (response.data.data[i].religion) {
                this.excel.religion = response.data.data[i].religion;
              }
              this.myData.push(JSON.parse(JSON.stringify(this.excel)));
              this.excel = {};
            }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getBooth() {
      // console.log("role=",this.role)
      this.appLoading = true;
      axios({
        url: "/booth/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.boothList = response.data.data;
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
        var dt = new Date(item);
        var day = dt.getDate();
        var year = dt.getFullYear();
        // var hours = dt.getHours();
        // var minutes = dt.getMinutes();
        dt = dt.toString();
        // var ampm = hours >= 12 ? "pm" : "am";
        // hours = hours % 12;
        // hours = hours ? hours : 12;
        // minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime =
          day +
          " " +
          dt.slice(4, 7) +
          " " +
          year
          //  +
          // " , " +
          // hours +
          // ":" +
          // minutes +
          // " " +
          // ampm;
  
        return strTime;
      },
  },
};
</script>
  <style scoped>
.v-text-field input {
  font-family: kumbhBold;
}
</style>
  